// Third party packages
import { CookieService } from 'ngx-cookie-service';
import { of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
import * as i3 from "ngx-cookie-service";
var PropertySuppliersInOutService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PropertySuppliersInOutService(apiService, helperService, cookieService) {
        this.apiService = apiService;
        this.helperService = helperService;
        this.cookieService = cookieService;
        /**
         * Filter-options cache, scoped by the currently requested company.
         * The service is a root singleton, so the cache survives navigation between
         * list views within the same session. A change of X-Requested-Company yields a
         * different cache key and therefore transparently invalidates the cached value.
         */
        this.filterOptionsCache = null;
    }
    /**
     * Create a new Tag NFC
     *
     * @since 1.0.0
     *
     * @param data Supplier In Out
     * @returns Observable<any>
     */
    PropertySuppliersInOutService.prototype.create = function (data) {
        return this.apiService.apiCall('POST', "supplier-in-out", data);
    };
    /**
     * Get all Suppliers In Out list of property
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    PropertySuppliersInOutService.prototype.getPropertyList = function (propertyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "supplier-in-out/property/" + propertyId, params);
    };
    /**
     * Get all Suppliers In Out list
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    PropertySuppliersInOutService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "supplier-in-out", params);
    };
    /**
     * Get the dropdown options (suppliers and operators) for the supplier-in-out
     * list filters, scoped to the currently requested company.
     *
     * Requires the `canReadSupplierInOutList` permission: callers must handle a
     * 403 by falling back to the legacy free-text filters.
     *
     * The successful payload is cached per company; the call is only re-issued
     * when X-Requested-Company changes. Errors are never cached.
     *
     * @since 3.0.0
     *
     * @returns Observable<SupplierInOutFilterOptions>
     */
    PropertySuppliersInOutService.prototype.getFilterOptions = function () {
        var _this = this;
        var requestedCompany = this.cookieService.get('requestedCompany') || '';
        if (this.filterOptionsCache && this.filterOptionsCache.company === requestedCompany) {
            return of(this.filterOptionsCache.options);
        }
        return this.apiService.apiCall('GET', "supplier-in-out/filter-options")
            .pipe(map(function (res) {
            var payload = (res && res.data) ? res.data : { suppliers: [], operators: [] };
            return {
                suppliers: Array.isArray(payload.suppliers) ? payload.suppliers : [],
                operators: Array.isArray(payload.operators) ? payload.operators : [],
            };
        }), tap(function (options) {
            _this.filterOptionsCache = { company: requestedCompany, options: options };
        }));
    };
    /**
     * Get an exportation file of all Tag NFC of property
     *
     * @since 1.0.0
     */
    PropertySuppliersInOutService.prototype.getExportProperty = function (propertyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "supplier-in-out/property/export/" + propertyId, {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all Tag NFC of property
     *
     * @since 1.0.0
     */
    PropertySuppliersInOutService.prototype.getExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', "supplier-in-out/export", {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Update fields with given tagId
     *
     * @since 1.0.0
     *
     * @param tagId ID of property to update
     */
    PropertySuppliersInOutService.prototype.updateFields = function (tagId, data) {
        return this.apiService.apiCall('PATCH', "supplier-in-out/" + tagId, data);
    };
    PropertySuppliersInOutService.prototype.delete = function (tagId) {
        return this.apiService.apiCall('DELETE', "supplier-in-out/" + tagId);
    };
    PropertySuppliersInOutService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PropertySuppliersInOutService_Factory() { return new PropertySuppliersInOutService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.CookieService)); }, token: PropertySuppliersInOutService, providedIn: "root" });
    return PropertySuppliersInOutService;
}());
export { PropertySuppliersInOutService };
